import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header align-items-center border-0 mt-4" }
const _hoisted_2 = { class: "card-title align-items-start flex-column" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder mb-2 text-dark" }, "En son yapılan işlemler", -1)
const _hoisted_4 = { class: "text-muted fw-bold fs-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_6 = { class: "card-body pt-5" }
const _hoisted_7 = { class: "timeline-label" }
const _hoisted_8 = { class: "timeline-label fw-bolder text-gray-800 fs-6" }
const _hoisted_9 = { class: "timeline-badge" }
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "fw-mormal timeline-content text-muted ps-3" }
const _hoisted_12 = {
  key: 0,
  class: "text-center mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.widgetClasses])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.data?.length ?? 0) + " işlem yapıldı", 1)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.data as LogDTO[]), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "timeline-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatDate(item.date)), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("i", {
                class: "fa fa-genderless text-warning fs-1",
                style: _normalizeStyle('color:'+_ctx.IIntegrationElement.statusColor({integrationType:parseInt(item.logIntegrationType) as IntegrationType},_ctx.ProductStatus.Open)+' !important'),
                title: _ctx.IIntegrationElement.friendlyName({integrationType:parseInt(item.logIntegrationType) as IntegrationType})
              }, null, 12, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.logDescription), 1)
          ]))
        }), 128))
      ]),
      (_ctx.hasMore)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-light-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('load-more')))
            }, " Daha Fazla ")
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}